import { render } from "./Attributes.vue?vue&type=template&id=df0e23fe"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/Attributes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df0e23fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df0e23fe', __exports__)) {
    api.reload('df0e23fe', __exports__)
  }
  
  module.hot.accept("./Attributes.vue?vue&type=template&id=df0e23fe", () => {
    api.rerender('df0e23fe', render)
  })

}


export default __exports__